import {useEffect, Fragment} from 'react'
import {connect} from 'react-redux'
import {Map} from 'immutable'
import PropTypes from 'prop-types'
import {readEndpoint} from 'redux-json-api'

import {currentUserConfig} from '../lib/userTools'
import {findRawResourceByAttributeId, findRawResourceById} from '../lib/plan_data/userData'
import routerUtils from '../lib/routerUtils'
import {webAppsUrl} from '../lib/urlTools'
import {isFirmUserWhitelistedForTfaSkip, isMandatoryTfaEnabled} from '../lib/tfaTools'
import Loader from './NewLoader'


export const PendingRequiredFirmUserActionCheck = props => {
  const {userConfig, firmConfig, organizationConfig, firm, isWhitelistedFirmUser} = props
  const isQuarterback = userConfig.get('quarterback')
  const isFirmUser = userConfig.get('firm-id') && !userConfig.get('client')
  const isFuneralHome = firm.get('firm-type') === 'funeral_home'

  const needsTfaSetup = !userConfig.get('tfa-enabled') && (
    isMandatoryTfaEnabled({organizationConfig, firmConfig}) ||
    isQuarterback ||
    (isFirmUser && isFuneralHome && !isWhitelistedFirmUser)
  )

  useEffect(() => {
    if (userConfig.get('firm-id') && !userConfig.get('client') && firm.isEmpty()) {
      props.readEndpoint(`firms/${userConfig.get('firm-id')}?include=client-seats,cobranding,firm-config,disclosure,firm-seats,organization.organization-config`)
      props.readEndpoint(`users/${userConfig.get('id')}?include=firm-user-config`)
    }
  }, [userConfig.get('firm-id'), userConfig.get('client'), firm.isEmpty()])

  useEffect(() => {
    if (needsTfaSetup)
      routerUtils.setLocation(webAppsUrl('auth/tfa-intro'))
  }, [needsTfaSetup])

  if (needsTfaSetup)
    return <Loader loading={true} />

  return (
    <Fragment>
      {props.children}
    </Fragment>
  )
}

PendingRequiredFirmUserActionCheck.propTypes = {
  userConfig: PropTypes.instanceOf(Map),
  firmConfig: PropTypes.instanceOf(Map),
  organizationConfig: PropTypes.instanceOf(Map),
  firm: PropTypes.instanceOf(Map),
  isWhitelistedFirmUser: PropTypes.bool,
  readEndpoint: PropTypes.func
}

PendingRequiredFirmUserActionCheck.defaultProps = {
  firmConfig: Map(),
  organizationConfig: Map(),
  firm: Map(),
  userConfig: Map(),
  isWhitelistedFirmUser: false
}

const mapStateToProps = state => {
  const userConfig = currentUserConfig(state.api)

  const firm = findRawResourceById({
    rawResource: state.api.firms,
    id: userConfig.get('firm-id')
  })

  const organizationConfig = findRawResourceByAttributeId({
    rawResource: state.api['organization-configs'],
    attribute: 'organization-id',
    id: firm.get('organization-id')
  })

  const firmConfig = findRawResourceByAttributeId({
    rawResource: state.api['firm-configs'],
    attribute: 'firm-id',
    id: firm.get('id')
  })

  const isWhitelistedFirmUser = isFirmUserWhitelistedForTfaSkip({
    firmUserId: userConfig.get('id'),
    settings: state.api.settings
  })

  return {userConfig, firmConfig, organizationConfig, firm, isWhitelistedFirmUser}
}

export default connect(mapStateToProps, {readEndpoint})(PendingRequiredFirmUserActionCheck)
